import { h } from 'preact'
import { Location } from '../../models/location'
import { formatPhoneNumber } from '../../shared/utils'
import Row from '../grid/row'
import Col from '../grid/col'

import * as style from './style.css'

function ExpiredInvitation({
    practiceName,
    location,
    website,
}: {
    practiceName: string
    location: Partial<Location>
    website: string
}) {
    const address = [location.street, location.city, location.state].filter((info) => Boolean(info)).join(', ')

    return (
        <section class={style.container}>
            <Row>
                <Col lgOffset={2} lg={8} mdOffset={2} md={8} xs={12} class={style.flexCenter}>
                    <img
                        class={style.image}
                        src="https://assets.simplifeye.co/self-scheduling/expired-invitation.svg"
                        alt="expired invitation"
                    />
                </Col>
            </Row>
            <Row>
                <Col
                    lgOffset={1}
                    lg={10}
                    mdOffset={1}
                    md={10}
                    xs={12}
                    class={`${style.flexCenter} ${style.textContainer}`}
                >
                    <h1 class={style.welcomeMessage}>Welcome back!</h1>
                    <strong>
                        Our records indicate that you have previously used this link to schedule an appointment.
                    </strong>
                    <span>
                        If you would like to make changes to your appointment or schedule another appointment, please
                        contact us directly.
                    </span>

                    <br />

                    <strong>{practiceName}</strong>
                    <span>{address}</span>
                    <span>{location.phoneNumber && formatPhoneNumber(location.phoneNumber)}</span>
                    <span>{website}</span>
                </Col>
            </Row>
        </section>
    )
}

export default ExpiredInvitation
